var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsoleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-sport-986950") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product-Individual-Fixed-Shop---Desktop",
    transform: "translate(-1006.000000, -51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-sport-986950",
    transform: "translate(1007.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#4F8B38",
    strokeWidth: 2,
    points: "20.952381 26.4182195 20.952381 0.952380952 39.047619 0.952380952 39.047619 40 22.5339048 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.9752163,
    y1: 19.9720091,
    x2: 29.574894,
    y2: 0.96105874,
    id: "Path",
    stroke: "#4F8B38",
    strokeWidth: 2,
    transform: "translate(30.275055, 10.466534) rotate(4.000000) translate(-30.275055, -10.466534) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.4761905,
    y1: 21.9047619,
    x2: 30.4761905,
    y2: 23.8095238,
    id: "Path",
    stroke: "#63BE40",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7036733,25.7142857 L7.00442512,25.7142857 C3.3973164,25.7142857 0.247688865,28.5852499 0.0146308184,32.3815655 C-0.24085261,36.5418073 2.88294637,40 6.77255226,40 C9.00527035,40 10.9830891,38.8593821 12.2155963,37.1011788 C12.8822371,36.1506491 13.8922089,35.5356529 15.0133087,35.5356529 L15.317918,35.5356529 C16.5108908,35.5356529 17.5927101,36.1762471 18.3149107,37.1776069 C19.7151214,39.1200948 22.0359665,40.2837482 24.5935097,39.9398218 C27.6325765,39.5314404 30.0875167,36.9001087 30.4314741,33.6893252 C30.8942209,29.3722986 27.7041108,25.7142857 23.7039442,25.7142857 L23.7036733,25.7142857 Z",
    id: "Path",
    stroke: "#4F8B38",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3809524,
    y1: 29.047619,
    x2: 14.5,
    y2: 28.5,
    id: "Path",
    stroke: "#D91415",
    transform: "translate(14.380952, 28.571429) rotate(26.000000) translate(-14.380952, -28.571429) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.3809524,
    y1: 29.047619,
    x2: 16.5,
    y2: 28.5,
    id: "Path-Copy",
    stroke: "#D91415",
    transform: "translate(16.380952, 28.571429) rotate(26.000000) translate(-16.380952, -28.571429) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.8,
    y1: 29.5238095,
    x2: 23.8,
    y2: 35.1904765,
    id: "Path",
    stroke: "#434143",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.4864691,
    y1: 32.2545398,
    x2: 20.9353795,
    y2: 32.5454602,
    id: "Path",
    stroke: "#434143",
    strokeWidth: 1.5,
    transform: "translate(23.710924, 32.400000) rotate(3.000000) translate(-23.710924, -32.400000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.19047619,
    y1: 30.4761905,
    x2: 6.19047619,
    y2: 31.9761905,
    id: "Path",
    stroke: "#F8BC00",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.19047619,
    y1: 34.2857143,
    x2: 6.19047619,
    y2: 35.7857143,
    id: "Path",
    stroke: "#F78226",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.57142857,
    y1: 32.8571429,
    x2: 7.07142857,
    y2: 32.8571429,
    id: "Path",
    stroke: "#63BE40",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.76190476,
    y1: 32.8571429,
    x2: 3.26190476,
    y2: 32.8571429,
    id: "Path",
    stroke: "#D91415",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsoleGreen);
export default __webpack_public_path__ + "static/media/console--green.ffe2006f6fcce876a5a7040afa12a3f3.svg";
export { ForwardRef as ReactComponent };